module.exports = __webpack_public_path__ + "img/list02-sp.411b0b69.png";